var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFire({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.29729 1.36093C9.52831 1.42228 9.72186 1.57988 9.82875 1.79367C10.2317 2.5996 10.5325 3.08874 10.835 3.48534C11.1413 3.88678 11.4653 4.21541 11.9581 4.70823C13.097 5.8471 13.6667 7.34144 13.6666 8.83303C13.6666 10.3246 13.097 11.8189 11.9581 12.9578C9.68005 15.2359 5.9866 15.2359 3.70854 12.9578C2.56968 11.8189 2 10.3246 2 8.83303C2 7.34144 2.56967 5.8471 3.70854 4.70823C3.94687 4.4699 4.3053 4.39861 4.6167 4.52759C4.92809 4.65657 5.13113 4.96044 5.13113 5.29749C5.13113 6.23067 5.1894 6.94171 5.46234 7.50886C5.61242 7.82072 5.84654 8.12562 6.25003 8.3977C6.3464 7.51373 6.52292 6.43673 6.76145 5.41448C6.94925 4.60963 7.18282 3.80611 7.46082 3.13606C7.59987 2.80091 7.75712 2.48179 7.9357 2.20626C8.10953 1.93807 8.33287 1.66516 8.62115 1.47297C8.82003 1.34038 9.06627 1.29958 9.29729 1.36093ZM9.60109 12.2674C8.62478 13.2437 7.04187 13.2437 6.06556 12.2674C5.57741 11.7793 5.33333 11.1395 5.33333 10.4997C5.33333 10.4997 6.06556 10.9163 7.4167 10.9163C7.4167 10.083 7.83336 7.583 8.45836 7.16633C8.87503 7.99966 9.11293 8.24375 9.60109 8.7319C10.0892 9.22006 10.3333 9.85986 10.3333 10.4997C10.3333 11.1395 10.0892 11.7793 9.60109 12.2674Z",
    fill: "#9756DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon-fire.bd922617e5d5e62a7b332b9b7cc15e0e.svg";
export { ForwardRef as ReactComponent };